/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MeasurementUnit } from './MeasurementUnit';
import {
    MeasurementUnitFromJSON,
    MeasurementUnitFromJSONTyped,
    MeasurementUnitToJSON,
    MeasurementUnitToJSONTyped,
} from './MeasurementUnit';
import type { WearDirection } from './WearDirection';
import {
    WearDirectionFromJSON,
    WearDirectionFromJSONTyped,
    WearDirectionToJSON,
    WearDirectionToJSONTyped,
} from './WearDirection';
import type { MeasuredDimension } from './MeasuredDimension';
import {
    MeasuredDimensionFromJSON,
    MeasuredDimensionFromJSONTyped,
    MeasuredDimensionToJSON,
    MeasuredDimensionToJSONTyped,
} from './MeasuredDimension';

/**
 * 
 * @export
 * @interface PartDimensionResponse
 */
export interface PartDimensionResponse {
    /**
     * 
     * @type {number}
     * @memberof PartDimensionResponse
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof PartDimensionResponse
     */
    partId?: number;
    /**
     * 
     * @type {number}
     * @memberof PartDimensionResponse
     */
    dimensionTypeId?: number;
    /**
     * 
     * @type {number}
     * @memberof PartDimensionResponse
     */
    observableItemId?: number;
    /**
     * 
     * @type {number}
     * @memberof PartDimensionResponse
     */
    baselineValue?: number;
    /**
     * 
     * @type {number}
     * @memberof PartDimensionResponse
     */
    limit?: number;
    /**
     * 
     * @type {MeasurementUnit}
     * @memberof PartDimensionResponse
     */
    measurementUnit?: MeasurementUnit;
    /**
     * 
     * @type {MeasuredDimension}
     * @memberof PartDimensionResponse
     */
    measuredDimension?: MeasuredDimension;
    /**
     * 
     * @type {WearDirection}
     * @memberof PartDimensionResponse
     */
    wearDirection?: WearDirection;
    /**
     * 
     * @type {string}
     * @memberof PartDimensionResponse
     */
    externalId?: string;
}



/**
 * Check if a given object implements the PartDimensionResponse interface.
 */
export function instanceOfPartDimensionResponse(value: object): value is PartDimensionResponse {
    return true;
}

export function PartDimensionResponseFromJSON(json: any): PartDimensionResponse {
    return PartDimensionResponseFromJSONTyped(json, false);
}

export function PartDimensionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartDimensionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'partId': json['partId'] == null ? undefined : json['partId'],
        'dimensionTypeId': json['dimensionTypeId'] == null ? undefined : json['dimensionTypeId'],
        'observableItemId': json['observableItemId'] == null ? undefined : json['observableItemId'],
        'baselineValue': json['baselineValue'] == null ? undefined : json['baselineValue'],
        'limit': json['limit'] == null ? undefined : json['limit'],
        'measurementUnit': json['measurementUnit'] == null ? undefined : MeasurementUnitFromJSON(json['measurementUnit']),
        'measuredDimension': json['measuredDimension'] == null ? undefined : MeasuredDimensionFromJSON(json['measuredDimension']),
        'wearDirection': json['wearDirection'] == null ? undefined : WearDirectionFromJSON(json['wearDirection']),
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
    };
}

export function PartDimensionResponseToJSON(json: any): PartDimensionResponse {
    return PartDimensionResponseToJSONTyped(json, false);
}

export function PartDimensionResponseToJSONTyped(value?: PartDimensionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'partId': value['partId'],
        'dimensionTypeId': value['dimensionTypeId'],
        'observableItemId': value['observableItemId'],
        'baselineValue': value['baselineValue'],
        'limit': value['limit'],
        'measurementUnit': MeasurementUnitToJSON(value['measurementUnit']),
        'measuredDimension': MeasuredDimensionToJSON(value['measuredDimension']),
        'wearDirection': WearDirectionToJSON(value['wearDirection']),
        'externalId': value['externalId'],
    };
}

